import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Edit, Clock, Eye, AlertTriangle, Info } from 'lucide-react';

export const SectionColorLegend: React.FC = () => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Info className="h-5 w-5" />
          Section Color Guide
        </CardTitle>
        <CardDescription>
          Understanding what each section color means for your role
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <div className="flex items-center gap-3 p-4 rounded-lg border bg-green-50 border-green-200 dark:bg-green-950 dark:border-green-800">
            <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
            <div>
              <div className="font-semibold text-green-800 dark:text-green-200">Completed</div>
              <div className="text-sm text-green-700 dark:text-green-300">✅ Done by you</div>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg border bg-blue-50 border-blue-200 dark:bg-blue-950 dark:border-blue-800">
            <Edit className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            <div>
              <div className="font-semibold text-blue-800 dark:text-blue-200">Available</div>
              <div className="text-sm text-blue-700 dark:text-blue-300">📝 You can edit</div>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg border bg-orange-50 border-orange-200 dark:bg-orange-950 dark:border-orange-800">
            <Clock className="h-6 w-6 text-orange-600 dark:text-orange-400" />
            <div>
              <div className="font-semibold text-orange-800 dark:text-orange-200">Waiting</div>
              <div className="text-sm text-orange-700 dark:text-orange-300">⏳ Your input needed</div>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg border bg-slate-50 border-slate-200 dark:bg-slate-800 dark:border-slate-700">
            <Eye className="h-6 w-6 text-slate-600 dark:text-slate-400" />
            <div>
              <div className="font-semibold text-slate-800 dark:text-slate-200">View Only</div>
              <div className="text-sm text-slate-700 dark:text-slate-300">👁️ For your role</div>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 rounded-lg border bg-red-50 border-red-200 dark:bg-red-950 dark:border-red-800">
            <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
            <div>
              <div className="font-semibold text-red-800 dark:text-red-200">Blocked</div>
              <div className="text-sm text-red-700 dark:text-red-300">❌ Prerequisites needed</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};